import {Button} from '@/components/ui/button/Button'
import {
    DialogDisclosure,
    DialogProvider,
    Dialog,
    DialogDismiss,
    DialogBody,
    DialogFooter
} from '@/components/ui/dialog-atoms/DialogAtoms'
import {PencilLineIcon} from '@/components/ui/icon/Icon'
import {
    ProjectDetailsDialogHeader,
    ProjectDetailsDialogHeading
} from '@/features/projects/components/project-details-dialog-atoms/ProjectDetailsDialogAtoms'
import {EditProjectPatientFormProvider} from '@/features/projects/components/project-form/edit-project-patient-form-provider/EditProjectPatientFormProvider'
import {ProjectExtended} from '@/features/projects/types'
import {useTranslation} from '@/translations/i18n'
import {useMemo} from 'react'
import {EditProjectPatientFormSections} from '@/features/projects/components/project-form/edit-project-patient-form-sections/EditProjectPatientFormSections'
import {useDialogContext} from '@ariakit/react'
import {EditProjectPatientFormFooter} from '@/features/projects/components/project-form/edit-project-patient-form-footer/EditProjectPatientFormFooter'

export const ProjectDetailsPatientEditDialog = ({project}: {project: ProjectExtended}) => {
    const {t} = useTranslation()
    return (
        <DialogProvider>
            <DialogDisclosure
                render={
                    <Button variant="ghost">
                        <PencilLineIcon />
                        {t('commons:edit')}
                    </Button>
                }
            />
            <Dialog width="800px" overflowY="unset">
                <DialogContent project={project} />
            </Dialog>
        </DialogProvider>
    )
}

const DialogContent = ({project}: {project: ProjectExtended}) => {
    const {t} = useTranslation()
    const dialogContext = useDialogContext()

    const projectPatientToDefaultValues = useMemo(
        () => ({
            id: project.id,
            livingConditions: project.livingConditions,
            rehabilitationFacility: project.rehabilitationFacility
        }),
        [project]
    )
    return (
        <>
            <ProjectDetailsDialogHeader>
                <ProjectDetailsDialogHeading>{t('projects:edit_patient_info')}</ProjectDetailsDialogHeading>
                <DialogDismiss />
            </ProjectDetailsDialogHeader>
            <EditProjectPatientFormProvider defaultValues={projectPatientToDefaultValues}>
                <DialogBody>
                    <EditProjectPatientFormSections patient={project.patient} />
                </DialogBody>
                <DialogFooter>
                    <EditProjectPatientFormFooter onCancel={() => dialogContext?.setOpen(false)} />
                </DialogFooter>
            </EditProjectPatientFormProvider>
        </>
    )
}
